import { createReducer, on } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';
import firebase from 'firebase';

export const authFeatureKey = 'auth';

export interface State {
  loading: boolean;
  loaded: boolean;
  success: boolean;
  credentials: {
    email: string;
    password: string;
  };
  error: any;
  token: string;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  credentials: null,
  success: false,
  error: null,
  token: null
};


export const reducer = createReducer(
  initialState,
  on(AuthActions.Login, (state, payload) => ({
    ...state,
    loading: true,
    credentials: {
      ...state.credentials,
      email: payload.credentials.email,
      password: payload.credentials.password
    }
  })),
  on(AuthActions.GoogleLoginSuccess, (state, payload) => ({
    ...state,
    loading: false,
    success: true,
    token: payload.token
  })),
  on(AuthActions.GoogleLoginFailure, (state, payload) => {
    return ({
      ...state,
      loading: false,
      success: false,
      error: {
        ...state.error,
        message: payload.message,
        code: payload.code
      }
    });
  }),
  on(AuthActions.GoogleLogin, state => ({ ...state, loading: true, loaded: true, error: null })),
  on(AuthActions.LoginFailure, (state, payload) => ({ ...state, loading: false, error: payload.error })),
  on(AuthActions.LoginSuccess, state => ({ ...state, loading: false, success: true })),
  on(AuthActions.CheckLogin, state => ({ ...state, loading: false })),
);

